module.exports = __webpack_public_path__ + "img/401.d653cf4b.png";